var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.fetching)?_c('el-cascader',{attrs:{"options":_vm.items,"props":{
    value: 'id',
    label: 'name'
  },"clearable":_vm.clearable,"size":_vm.size,"placeholder":"请选择地区"},on:{"expand-change":_vm.handleItemChange},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }